import {
  REQUEST_SET_DOCUMENT_CONTENT,
  RESET_STORE_DOCUMENT,
  REQUEST_GET_DOC_BY_DOCUMENTUM_ID,
} from 'containers/common/UploadDocument/constants';

export const requestSetDocumentContent = (payload: any) => ({
  type: REQUEST_SET_DOCUMENT_CONTENT,
  payload,
});

export const resetStore = () => ({
  type: RESET_STORE_DOCUMENT,
});

export const requestGetDocByDocumentumId = (url: string) => ({
  type: REQUEST_GET_DOC_BY_DOCUMENTUM_ID,
  url,
});
